/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  namedImages,
  useCameraFrameStore,
  useLayoutStore,
  useProductStore,
  useSeriesStore,
  useStackingStore
} from '@/store'
import { computed } from 'vue'

import { getNetworkType } from '@/utils/network'
import { win } from '@/utils/device'
import useSelect from './use-select'

export type AlertState = {
  visible: boolean
  message: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any
  tips: string
  reportValue: string
  buttonText: string
  otherActionText?: string

  onClose(): void
  onConfirm?: () => void
  otherAction?: () => void
}

const useAlert = () => {
  const productStore = useProductStore()
  const stackingStore = useStackingStore()
  const seriesStore = useSeriesStore()
  const cameraFrameStore = useCameraFrameStore()
  const layoutStore = useLayoutStore()
  const {
    isStackingsSelected,
    selectedStackingSetKey,
    selectableStackings,
    selectedId
  } = useSelect()

  const isNetworkOk = async () => {
    try {
      const type = await getNetworkType()
      console.log('[[ Network ] Result ]', { type })
      layoutStore.hasUnreadNetworkError = false
      return true
    } catch (error) {
      console.log('[[ Network ] Error ]', { error })
      stackingStore.reset()
      seriesStore.reset()
      productStore.reset()
      layoutStore.hasUnreadNetworkError = true
      layoutStore.isFromNewWorksToTryOn = false
      return false
    }
  }

  const closeCameraFailedAlert = () => {
    stackingStore.reset()
    seriesStore.reset()
    productStore.reset()
    cameraFrameStore.resetStates()
  }

  const closeNetworkErrorAlert = () => {
    cameraFrameStore.resetStates()
    layoutStore.hasUnreadNetworkError = false
  }

  const closeCameraErrorAlert = () => {
    stackingStore.reset()
    seriesStore.reset()
    productStore.reset()
    cameraFrameStore.resetStates()
  }

  const refresh = () => {
    let skuid = selectedId.value || null
    const set: string[] = []
    if (skuid) {
      if (isStackingsSelected.value) {
        const stacking = selectableStackings.value.find(s => s.guid === skuid)
        skuid = stacking?.code || null

        set.push(selectedStackingSetKey.value!.toLowerCase())
      } else {
        set.push(productStore.selectionSource)
      }
    } else {
      set.push('allworks')
    }

    const query = {
      skuid,
      reset: set.join('$')
    }
    const queryString = Object.entries(query)
      .filter(([, v]) => v != null)
      .map(kv => kv.join('='))
      .join('&')
    console.log('[[ Weixin ] Reload ]', { qs: queryString })
    win.wx?.miniProgram?.redirectTo({
      url: `${process.env.VUE_APP_REDIRECT_PATH}?${queryString}`
    })
  }

  const hasAlertShown = computed(
    () =>
      cameraFrameStore.hasUnreadCameraFailed ||
      cameraFrameStore.hasUnreadCameraError ||
      layoutStore.hasUnreadNetworkError
  )

  const alertState = computed<AlertState>(() => {
    if (layoutStore.hasUnreadNetworkError) {
      return {
        visible: true,
        message: '网络不可用',
        reportValue: 'Network_Not_Available',
        icon: namedImages.icon_net_err,
        tips: '您的网速过慢，请检查网络连接。',
        buttonText: '我已知晓',
        onClose: closeNetworkErrorAlert
      }
    }
    if (cameraFrameStore.hasUnreadCameraFailed) {
      return {
        visible: true,
        message: '相机访问被拒绝',
        reportValue: 'Camera_Access_Denied',
        icon: namedImages.icon_camera_failed,
        tips: '确认开启您的相机访问权限？',
        buttonText: '确认开启',
        // otherActionText: '刷新',
        onClose: closeCameraFailedAlert,
        onConfirm: refresh
        // otherAction: refresh
      }
    }
    if (cameraFrameStore.hasUnreadCameraError) {
      return {
        visible: true,
        message: '发生错误',
        reportValue: 'Occurred_Error',
        icon: namedImages.icon_err,
        tips: '请稍后再试',
        buttonText: '确认',
        onClose: closeCameraErrorAlert
      }
    }
    return {
      visible: false,
      message: '',
      reportValue: '',
      icon: null,
      tips: '',
      buttonText: '',
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClose: () => {}
    }
  })

  return {
    alertState,
    hasAlertShown,
    isNetworkOk
  }
}

export default useAlert
